


import React, { useRef, useState, useEffect } from 'react';
import { Pencil, Ellipsis, Trash2, CloudUpload, ChevronDown, ChevronUp, Plus, ShieldX, Table, Eye } from 'lucide-react';
import { X } from 'lucide-react';
import './SitesTask.css';
import TaskNotes from '../sitesDetail/TaskNotes'
import { getTasks } from '../../../../redux/reduxApi/taskReduxApi';
import Notes from '../../../../utils/notes/Notes';
import { useDispatch, useSelector } from 'react-redux';
import { addTask } from '../../../../redux/api/taskApi/TaskApi';
import { addTaskAction } from '../../../../redux/reduxSlice/TaskSlice';
import { updateTask } from '../../../../redux/api/taskApi/TaskApi';
import { deleteTask } from '../../../../redux/api/taskApi/TaskApi';
import { toast } from 'react-toastify';
import { getSitesById } from '../../../../redux/api/sitesApi/SitesApi';
import { deleteTaskAction } from '../../../../redux/reduxSlice/TaskSlice';
import { updateTaskAction } from '../../../../redux/reduxSlice/TaskSlice';

const SpecificTaskDetailView = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [sitesId, setSitesId] = useState(props.sitesId || null)
  // console.log('sitesId',sitesId)
  const [taskData, setTaskData] = useState(props.taskData || { tab: [] })
  const [item, setItem] = useState()
  // const [taskData, setData] = useState([])
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [deleteTaskROWID, setDeleteTaskROWID] = useState()
  const [selectedRows, setSelectedRows] = useState([]);
  const [updateTaskROWID, setUpdateTaskROWID] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(null); // Store the data related to the popup

  const [tables, setTables] = useState({
    tab: [
      {
        title: "1. Pre-Installation Phase",
        rows: [
          {
            taskName: " ",
            description: "",
            status: " ",
            startDate: " ",
            dueDate: " ",
            duration: " ",
            taskPriority: " ",
            completionPercentage: " ",
            attachment: "",
            sitesId: props.sitesId,
            masterId: props.sitesId,
            ROWID: '',
            subtasks: [
              {
                name: "",
                status: " ",
                start_date: " ",
                due_date: " ",
                duration: " ",
                priority: " ",
                completion_percentage: ""
              },
              ,
            ],
            // isCollapsed: true, // Manage collapsible state
          },

        ],
      },

    ],
  });

  // console.log('<<<<<<<<<<<<<<<<<<<<<<<<<<<ROWID',tables)

  useEffect(() => {
    console.log("props.taskData]-", props.taskData)

  }, [props.taskData]);

  console.log('delete>>>>>>>>>>>>>>>>>>>ROWID', deleteTaskROWID)
  const handleDelete = (e, ROWID) => {
    e.stopPropagation();
    setLoading(true);

    deleteTask(ROWID) // API call to delete the task
      .then(() => {
        dispatch(deleteTaskAction([ROWID])); // Remove from Redux store
        toast.success("Task deleted successfully");
        fetchRelatedSites(); // Refresh data
      })
      .catch(() => {
        toast.error("Failed to delete task");
      })
      .finally(() => {
        setLoading(false);
      });
  };


  const fetchRelatedSites = () => {
    setLoading(true);
    try {
      getSitesById(sitesId)
        .then((response) => {
          if (response.data.success) {

            // console.log('taskresponse', response.data.response[6])
            const rows = response.data.response[6].map(({ tasks }) => {
              tasks.subtasks = JSON.parse(tasks.subTasks);
              tasks.subtasks = tasks.subtasks?.filter(ele => ele);
              return tasks;
            })

            console.log("ROWWWWWWWWWWWWWWW-", rows)
            const data = { tab: [{ title: "", rows }] };
            setTables(data);
          }
        })
        .catch((error) => {
          toast.error("Error fetching related sites");
          console.error("Error fetching related sites:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      toast.error("Unexpected error");
      console.error("Unexpected error:", error);
    }
  };

  useEffect(() => {
    fetchRelatedSites();
  }, []);

  const handleSubmit = (e) => {
    e?.preventDefault();
    console.log("tables-", tables);
    addTask(tables)
      .then((response) => {
        // console.log('tablerepppppppppppp', response)
        if (response.data.success) {
          const ROWID = response.data.ROWID;
          fetchRelatedSites();
          // dispatch(addTaskAction({ ROWID, tasks }));
          // setFormData();
          // setShowProgressBar(false);
          toast.success("Task added successfully!");
          // handleOnClose();
        } else {
          toast.error("Unable to add Task, Please try again!");
          console.log("error")
        }
      })
      .catch((error) => {
        console.error("API Error", error);
        // setShowProgressBar(false);
        toast.error("Failed to add Task. Please try again.");
      })

  };


  const handelOnUpdate = (e) => {
    e.preventDefault();

    // Assuming `tables` holds the updated task data that needs to be updated in the backend
    updateTask(tables).then((response) => {
      console.log({ response });

      if (response.data.success) {
        // Update the Redux state with the new ROWID after a successful API call
        setTables((prev) => ({
          ...prev,
          ROWID: response?.data.ROWID,
        }));

        // Dispatch the action to update the task in the Redux state
        dispatch(updateTaskAction(tables));

        // Show success toast message
        toast.success("Jobsite Updated Successfully !!");
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Jobsite Update Failed!");
    }).finally(() => {
      // Any cleanup actions (like resetting progress bar or disabling buttons) go here
    });
  };
  const statusOptions = [
    { value: 'Completed', label: '🔵 Backlog', color: '#007bff' },
    { value: 'Working on it', label: '🟡 Working on it', color: '#ffc107' },
    { value: 'Ready for Review', label: '🟢 Ready for Review', color: '#28a745' },

  ];
  const priorityOptions = [
    { value: 'None', label: '⚪None', color: 'pink' },
    { value: 'Low', label: '🟦Low ', background: '#c7e9ff', color: ' #25618a' },
    { value: 'Medium', label: '🟧Medium ', background: '#ffa500', color: ' #fff' },
    { value: 'High', label: ' 🟥High ', background: '#ff7f7f ', color: 'white' },
  ];

  const completionPercentageOptions = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

  const handleTitleChange = (e, tableIndex) => {
    const newTables = [...tables.tab];
    newTables[tableIndex].title = e.target.value;
    setTables({ ...tables, tab: newTables });
  };

  const handleTaskChange = (value, taskIndex, field, tableIndex) => {
    const newTables = [...tables.tab];
    newTables[tableIndex].rows[taskIndex][field] = value;
    setTables({ ...tables, tab: newTables });
  };

  const handleSubtaskChange = (value, taskIndex, subtaskIndex, field, tableIndex) => {
    const newTables = [...tables.tab];
    newTables[tableIndex].rows[taskIndex].subtasks[subtaskIndex][field] = value;
    setTables({ ...tables, tab: newTables });
  };

  const addRow = (tableIndex) => {
    const newTables = [...tables.tab];
    newTables[tableIndex].rows.push({
      taskName: "",
      description: "",
      status: " ",
      startDate: "",
      dueDate: "",
      duration: "",
      taskPriority: "",
      completionPercentage: "",
      attachment: "",
      sitesId: "",
      masterId: props.sitesId,
      subtasks: [],
      isCollapsed: true, // Initial state of collapsible row
    });
    setTables({ ...tables, tab: newTables });
  };

  const addSubtask = (taskIndex, tableIndex) => {
    const newTables = [...tables.tab];
    newTables[tableIndex].rows[taskIndex].subtasks.push({
      name: "",
      status: " ",
      start_date: "",
      due_date: "",
      priority: " ",
      duration: "",
      masterId: props.sitesId,
      completion_percentage: " ",
    });
    setTables({ ...tables, tab: newTables });
  };

  const deleteRowSubtask = (tableIndex, taskIndex, subtaskIndex) => {
    const newTables = [...tables.tab];
    newTables[tableIndex].rows[taskIndex].subtasks.splice(subtaskIndex, 1);
    setTables({ ...tables, tab: newTables });
  };

  const deleteRow = (taskIndex, tableIndex) => {
    const newTables = [...tables.tab];
    newTables[tableIndex].rows.splice(taskIndex, 1);
    setTables({ ...tables, tab: newTables });
  };

  const deleteTable = (tableIndex) => {
    const newTables = [...tables.tab];
    newTables.splice(tableIndex, 1);
    setTables({ ...tables, tab: newTables });
  };

  const toggleCollapse = (taskIndex, tableIndex) => {
    const newTables = [...tables.tab];
    newTables[tableIndex].rows[taskIndex].isCollapsed = !newTables[tableIndex].rows[taskIndex].isCollapsed;
    setTables({ ...tables, tab: newTables });
  };

  const openPopup = (taskData) => {
    setPopupData(taskData); // Set the data for the popup
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setPopupData(null); // Reset popup data
  };

  return (

    <div className="custom-scroll ">
      {tables?.tab?.map((table, tableIndex) => (
        <div key={tableIndex} className="mb-2 table-div ms-3">
          <div className="d-flex gap-2 align-items-center mb-3 w-100">
            <div>
              <Ellipsis
                color="#ff176b"
                className="mb-0 dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              />
              <ul className="dropdown-menu dropdown-menu-end mt-2" aria-labelledby="dropdownMenu2">
                <li>
                  <button className="dropdown-item" type="button" onClick={() => deleteTable(tableIndex)} >
                    Remove Area
                  </button>
                </li>
              </ul>
            </div>

            <div className=" mt-2 d-flex" style={{ width: '97vw', background: 'white', borderRadius: '10px' }}>
              <input type="text mx-3" className="my-2 outline" value={table.title} onChange={(e) => handleTitleChange(e, tableIndex, 'title')} style={{ border: "none", fontWeight: "600", width: '100%' }} />
              <div className='d-flex viewBtn' style={{ alignItems: 'center', cursor: 'pointer' }}>
                <span> <Eye color="#ff176b" size="16px" strokeWidth="1" />  </span>
                <span > View</span> </div>
            </div>
          </div>
          <table className="table table-responsive">
            <thead>
              <tr className="tr-color">
                {["Actions", "Task Name", "Status", "Start Date", "Due Date", "Duration", "Priority", "Completion"].map((column, columnIndex) => (
                  <th className="th-style" key={columnIndex} scope="col">
                    {column}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {table.rows.map((task, taskIndex) => (
                <React.Fragment key={taskIndex}>
                  <tr className="tr-color row-hover">
                    <td>
                      <div className='' style={{ display: 'flex' }}> <span>
                        <Trash2 color="#ff176b" size="16px" strokeWidth="1" style={{ marginTop: "10px", cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent row expansion when clicking delete
                            setDeleteTaskROWID(task.ROWID); // Set the ROWID of the row being deleted
                            handleDelete(e, task.ROWID); // Pass ROWID to delete function
                          }} />
                      </span>
                        <span><Eye color="#ff176b" size="16px"
                          strokeWidth="1"
                          style={{ marginTop: "10px", cursor: "pointer", marginLeft: "6px" }}
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent row expansion when clicking update
                            setUpdateTaskROWID(task.ROWID); // Set the ROWID of the task being updated
                            handelOnUpdate(e, task.ROWID); // Pass ROWID to the update function
                          }}
                        /></span>  </div>
                      <div className='my-0' style={{ position: "absolute", display: "inline-block" }}>
                        {/* Ellipsis Icon */}
                        <span className="left-icon ">
                          <Ellipsis
                            color="#ff176b"
                            size={16}
                            style={{ cursor: "pointer" }}
                            onClick={() => setPopupOpen(!isPopupOpen)}
                          />
                        </span>

                        {/* Popup Menu */}
                        {isPopupOpen && (
                          <div
                            className="popup-menu"
                            style={{ position: "absolute", top: "20px", left: "0", background: "#fff", boxShadow: "0px 4px 6px rgba(0,0,0,0.1)", padding: "10px", borderRadius: "5px", zIndex: 10, }} >
                            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                              <li
                                style={{ cursor: "pointer", padding: "5px 10px" }}
                                onClick={() => {
                                  addSubtask(tableIndex, taskIndex);
                                  setPopupOpen(false); // Close the popup after clicking
                                }}
                              >
                                ➕ Add Subtask
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>


                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={task.taskName}
                        onChange={(e) => handleTaskChange(e.target.value, taskIndex, "taskName", tableIndex)}
                        style={{ border: "none" }}
                      />
                      <span onClick={() => toggleCollapse(taskIndex, tableIndex)} style={{ cursor: "pointer" }}>
                        {task.isCollapsed ? (
                          <ChevronUp className="drop-icon" size={16} />
                        ) : (
                          <ChevronDown className="drop-icon" size={16} />
                        )}
                      </span>
                      <span onClick={openPopup} className="open-icon"> <CloudUpload size={16} /></span>
                    </td>
                    <td>
                      <select value={task.status} className="form-select" onChange={(e) => handleTaskChange(e.target.value, taskIndex, "status", tableIndex)} style={{ border: "none" }}
                      >
                        {statusOptions.map((option, index) => (
                          <option key={index} value={option.value}>
                            {option.icon} {option.label}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <input type="date" className="form-control" value={task.startDate} onChange={(e) => handleTaskChange(e.target.value, taskIndex, "startDate", tableIndex)} style={{ border: "none" }} />
                    </td>
                    <td>
                      <input type="date" className="form-control" value={task.dueDate} onChange={(e) => handleTaskChange(e.target.value, taskIndex, "dueDate", tableIndex)} style={{ border: "none" }} />
                    </td>

                    <td> <input
                      type="text"
                      className="form-control "
                      value={task.duration}
                      onChange={(e) => handleTaskChange(e.target.value, taskIndex, "duration", tableIndex)}
                      style={{ border: "none" }}
                    /></td>
                    <td>
                      <select
                        value={task.taskPriority}
                        className="form-select"
                        onChange={(e) => handleTaskChange(e.target.value, taskIndex, "taskPriority", tableIndex)}
                        style={{ border: "none" }}
                      >
                        {priorityOptions.map((option, index) => (
                          <option key={index} value={option.value}>
                            {option.icon} {option.label}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <select value={task.completionPercentage}
                        className="form-select"
                        onChange={(e) => handleTaskChange(e.target.value, taskIndex, "completionPercentage", tableIndex)}
                        style={{ border: "none" }}
                      >
                        {completionPercentageOptions.map((percentage, index) => (
                          <option key={index} value={percentage}>
                            {percentage}%
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>

                  {!task.isCollapsed && task.subtasks && (
                    <>
                      {task.subtasks?.map((subtask, subtaskIndex) => (
                        <tr key={`subtask-${subtaskIndex}`} className="tr-color row-hover">
                          <td>
                            <ShieldX color="#ff176b" size="16px" strokeWidth="1" style={{ marginTop: "10px", cursor: "pointer", marginLeft: '8px' }} onClick={(e) => {
                              e.stopPropagation();
                              deleteRowSubtask(tableIndex, taskIndex, subtaskIndex);
                            }}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={subtask.name}
                              onChange={(e) =>
                                handleSubtaskChange(e.target.value, taskIndex, subtaskIndex, "name", tableIndex)}
                              style={{ border: "none", }}
                            />
                          </td>
                          <td>
                            <select
                              value={subtask.status}
                              className=""
                              onChange={(e) =>
                                handleSubtaskChange(
                                  e.target.value,
                                  taskIndex,
                                  subtaskIndex,
                                  "status",
                                  tableIndex
                                )
                              }
                              style={{ border: "none" }}
                            >
                              {statusOptions.map((option, index) => (
                                <option key={index} value={option.value}>
                                  {option.icon} {option.label}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <input
                              type="date"
                              className="form-control"
                              value={subtask.start_date}
                              onChange={(e) =>
                                handleSubtaskChange(
                                  e.target.value,
                                  taskIndex,
                                  subtaskIndex,
                                  "start_date",
                                  tableIndex
                                )
                              }
                              style={{ border: "none" }}
                            />
                          </td>
                          <td>
                            <input
                              type="date"
                              className="form-control"
                              value={subtask.due_date}
                              onChange={(e) =>
                                handleSubtaskChange(e.target.value, taskIndex, subtaskIndex, "due_date", tableIndex
                                )
                              }
                              style={{ border: "none" }}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={subtask.duration}
                              onChange={(e) =>
                                handleSubtaskChange(e.target.value, taskIndex, subtaskIndex, "duration", tableIndex)}
                              style={{ border: "none" }}
                            />
                          </td>
                          <td>
                            <select
                              value={subtask.priority}
                              className="form-select"
                              onChange={(e) => handleSubtaskChange(e.target.value, taskIndex, subtaskIndex, "priority", tableIndex)}
                              style={{ border: "none" }} >
                              {priorityOptions.map((option, index) => (
                                <option key={index} value={option.value}>
                                  {option.icon} {option.label}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <select
                              value={subtask.completion_percentage}
                              className="form-select"
                              onChange={(e) =>
                                handleSubtaskChange(e.target.value, taskIndex, subtaskIndex, "completion_percentage", tableIndex)}
                              style={{ border: "none" }}
                            >
                              {completionPercentageOptions.map((percentage, index) => (
                                <option key={index} value={percentage}>
                                  {percentage}%
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>
                      ))}

                      {/* This row is now outside the map, so it only appears once */}
                      <tr className="add-subtask-row">
                        <td colSpan={8}>
                          <input type="text" className="mb-2 form-control" placeholder="+ Add Subtask" onClick={() => addSubtask(taskIndex, tableIndex)} style={{ border: "none", paddingLeft: "50px" }} />
                        </td>
                      </tr>
                    </>
                  )}

                </React.Fragment>

              ))}
            </tbody>
          </table>

        </div>
      ))}

      {/* Popups */}
      {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <div className="popup-header">
              <X color="#ff176b" size={16} onClick={closePopup} />
            </div>
            <div className="popup-body">
              <div className="text-center mt-4 mb-4">
                <button className="create-button">
                  <TaskNotes />
                </button>
              </div>
              <div className="mt-4">
                <h6>Documents</h6>
                <input
                  type="file"
                  onChange={(e) => console.log(e.target.files)}
                  className="form-control mt-2"
                />
              </div>
            </div>
            <div className="popup-footer mt-4 text-center">
              <button className="btn create-button" onClick={closePopup}>
                Save
              </button>
              <button className="btn create-button" onClick={closePopup}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SpecificTaskDetailView;



